<template>
    <!-- 案例详情 -->
    <div class="case-detail">
        <!-- 图片列表 -->
        <div ref="main" class="case-img" v-for="item in caseDetailList">
            <van-image style="width: 100%" :src="item" />
        </div>
    </div>
</template>

<script>
import { Notify } from 'vant';
import {getCaseDetailList,UPLOAD_FILE_PATH} from "@/https/http.js";
export default {
    name:'case-detail',
    data(){
        return{
            UPLOAD_FILE_PATH:UPLOAD_FILE_PATH,
            caseDetailList: []
        }
    },
    methods: {
        querytCaseDetailList(){
            let caseId = this.$route.query.caseId;
            getCaseDetailList({"caseId":caseId}).then(res=>{
            if(res.data&&res.data.length>0){
                this.caseDetailList = []
                res.data.forEach(item => {
                    this.caseDetailList.push(this.UPLOAD_FILE_PATH + item) 
                });
            }
        })
        }
        
    },
    created(){
        this.querytCaseDetailList()
    }
}
</script>

<style lang="less" scoped>
    .case-detail{
        width: 100%;
        .case-img{
            left: 2%;
            right: 2%;
            width: 96%;
            position: relative;
            margin-bottom: -15px;
            van-image{
                width: 100%;
            }
        }
        .button{
            left: 10%;
            width: 80%;
            position: fixed;
            bottom: 50px;
        }
    }
    .mytitle {
        text-align: center;
        font-size: 16px;
        margin-top: 20px;
        position: relative;
        height: 50px;
        span {
            width: 50%;
            height: 2px;
            background-color: #ccc;
            display: inline-block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        h3 {
            width: 30%;
            background-color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
